import { useEffect, useState } from "react";

function Loader() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [show]);
  return (
    <>
      {show && (
        <div className="loader-wrapper">
          <div className="theme-loader">
            <div className="loader-p"></div>
          </div>
        </div>
      )}
    </>
  );
};
export default Loader;